import * as designsTypes from "state/entities/designs/designsTypes";

export const initState = {
  isCreatingDraft: false
};

const designsPageReducers = (state = initState, action) => {
  switch (action.type) {
    case designsTypes.DESIGNS_DRAFTS_CREATE_REQUEST: {
      return {
        ...state,
        isCreatingDraft: true
      };
    }

    case designsTypes.DESIGNS_DRAFTS_CREATE_REQUEST_SUCCESS:
    case designsTypes.DESIGNS_DRAFTS_CREATE_REQUEST_FAILURE: {
      return {
        ...state,
        isCreatingDraft: false
      };
    }

    default:
      return state;
  }
};

export default designsPageReducers;
